import { useMemo } from 'react';
import { Breadcrumb } from '../layout/navigation/breadcrumb/Breadcrumb';
import { HeaderContainer } from '../layout/page/HeaderContainer';
import { PageTagline } from '../layout/page/PageTagline';
import { WorkflowHeaderProps } from './types';

export const WorkflowHeader = ({
  selectedWorkflow,
  loading,
}: WorkflowHeaderProps) => {
  const getBreadcrumbItems = () => {
    const baseItem = { name: 'Workflows', url: '/workflows' };

    if (loading) {
      return [baseItem, { name: 'Loading...' }];
    }

    if (selectedWorkflow) {
      return [
        baseItem,
        {
          name:
            selectedWorkflow.data.subject ||
            selectedWorkflow.title ||
            'Untitled',
        },
      ];
    }

    return [baseItem];
  };

  const taglineMessage = useMemo(() => {
    if (loading) return 'Loading workflow details...';

    if (selectedWorkflow) {
      return `Details for workflow from ${selectedWorkflow.data.from_address || 'Unknown sender'}`;
    }

    return 'Monitor and track LLM agent activity and processing';
  }, [loading, selectedWorkflow]);

  return (
    <HeaderContainer>
      <Breadcrumb items={getBreadcrumbItems()} />
      <PageTagline message={taglineMessage} />
    </HeaderContainer>
  );
};
